import { FormGroup, FormControl } from '@angular/forms';
import { Endereco } from 'src/app/models/endereco';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { FormLaudoComponent } from '../form-laudo.component';
import { LaudoInput } from 'src/app/models/laudo-input';

export const pesquisaCep = (element:LaudoInput, values:any[], parent:FormLaudoComponent) => {

    let control = element.control as FormControl;

    control.valueChanges.pipe(distinctUntilChanged(), filter((v:string) => v.length == 10)).subscribe(v => {
        if (parent.step) {
            let form = parent.step.form as FormGroup;
            parent.enderecoService.pesquisaCEP(v).then( (r:Endereco) => {
                if(!r.erro) {
                    values.forEach(v => {
                        let [controlName,responseName] = v.split('|');
                        let c = form.get(controlName)  
                        c.patchValue(r[responseName]);
                    })
                }
            })
        }
    })
}
